import TemplateView from "../TemplateView";
import {isEscapePressed} from "../atBrowserUtils"

export default class SearchField extends TemplateView{
    constructor({
        onFieldChange = (text) => {}
    }){
        super();
        this.params = {
            onFieldChange,
        }
    }
    
    templateHtml(){
        return "<div class='searchField'>" +
               "  <table class='containerTable' cellspacing='0' cellpadding='0'>" +
               "    <tr>" +
               "      <td class='inputColumn'>" +
               "        <div class='cellWrapper'><input type='text' placeholder='<%=placeholder%>' maxlength='255'/></div>" +
               "      </td>" +
               "      <td class='iconColumn'><div class='icon'>&nbsp;</div></td>" +
               "    </tr>" +
               "  </table>" +
               "</div>"; 
    }
    
    afterRender()
    {
        let self = this;
        this.$input = this.find("input");
        this.$icon = this.find(".icon");
        this.$input.placeholder();
        this.$input.valueChanged(function()
                                 {
                                     let text = self.$input.pVal();
                                     self.$el.toggleClass("hasText", !!text);

                                     clearTimeout(self.timer);
                                     self.timer = setTimeout(function()
                                                             {
                                                                 self.params.onFieldChange(text);
                                                             }, 500);
                                 });
        this.$input.keyup(function(e)
                          {
                              if (isEscapePressed(e))
                                  self.clear()
                          });
        this.$input.focus(function(e)
                          {
                              self.$el.addClass('focusing');
                          });

        this.$input.blur(function(e)
                         {
                             self.$el.removeClass('focusing');
                         });
        this.$icon.click(function()
                         {
                             self.clear();
                         });
    }

    messageKeys(){
        return {
            placeholder: "task.list.search_placeholder"
        }
    }

    clear(){
        let text = this.$input.pVal();
        if (text)
        {
            this.$input.pVal("");
            this.$input[0].prevValue = "";
            this.$el.removeClass("hasText");
            clearTimeout(this.timer);
            this.params.onFieldChange("");
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/SearchField.js